import React from 'react';
import Icon from '../../../assets/images/page-footer/ssl-icon.svg';
import { useComponentsTranslations } from '../../../providers';
import { SidedIconTrustBuilder } from '../SidedIconTrustBuilder';
export const SSLSecurePayment = () => {
    const { t } = useComponentsTranslations();
    const titleKey = 'ssl_certificate.title';
    return (React.createElement(SidedIconTrustBuilder, { title: t(titleKey), description: t('ssl_certificate.information_encryption'), icon: React.createElement(Icon, null) }));
};
//# sourceMappingURL=SSLSecurePayment.js.map